module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-4 col-form-label"
  }, [_vm._v("Пользователи")]), _vm._v(" "), _c('div', {
    staticClass: "col-8"
  }, [_c('multiselect', {
    attrs: {
      "options": _vm.users,
      "searchable": true,
      "multiple": true,
      "close-on-select": true,
      "show-labels": false,
      "placeholder": _vm.placeholder,
      "track-by": "id",
      "label": "fullname",
      "loading": _vm.loading
    },
    on: {
      "input": _vm.changeUsers,
      "open": _vm.loadUsers
    },
    model: {
      value: (_vm.selectedUsers),
      callback: function($$v) {
        _vm.selectedUsers = $$v
      },
      expression: "selectedUsers"
    }
  }, [_c('span', {
    attrs: {
      "slot": "noResult"
    },
    slot: "noResult"
  }, [_vm._v("Пользователь не найден.")])])], 1)])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-0d1a1ced", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// /home/alarmplan/staging/shared/frontend/~/vue-loader/lib/template-compiler?{"id":"data-v-0d1a1ced"}!/home/alarmplan/staging/shared/frontend/~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Techcenter/components/TcSelectUsers.vue
// module id = 997
// module chunks = 1